'use client'

import React, { forwardRef, memo, useImperativeHandle } from 'react'
import { useTranslations } from 'next-intl'
import { TEmailSchema, useMediaQuery } from '@segway/core'

import { ItemEditIcon } from '@/components/icons'
import { Checkbox, Form, FormControl, FormField, FormItem, FormMessage, Input } from '@/ui'

import useContactInformation from '../../../../../../hooks/checkout/useContactInformation'

/**
 * 结算页联系信息组件（仅游客）
 *
 */

export interface ContactInformationRef {
  handleValidateForm: (cb: (values: TEmailSchema) => void) => void
  isSubscribe: boolean
}

const ContactInformation = forwardRef<ContactInformationRef>(({}, ref) => {
  const {
    form,
    onSubmit,
    isLoggedIn,
    curEmail,
    isEdit,
    handleEditEmail,
    inputRef,
    isSubscribe,
    onSubscribeChange,
  } = useContactInformation()

  const responsive = useMediaQuery()
  const t = useTranslations('Cart')

  useImperativeHandle(ref, () => ({
    handleValidateForm: (cb: (values: TEmailSchema) => void) => {
      form.handleSubmit(cb)()
    },
    isSubscribe,
  }))

  return isLoggedIn ? null : (
    <div className="space-y-2 xl:space-y-[40px]">
      <div className="rounded-[12px] bg-white px-3 py-4 xl:p-0">
        <p className="mb-3 text-[16px] xl:mb-4 xl:text-[20px]">{t('contact_information')}</p>
        {isEdit ? (
          <Form {...form}>
            <form>
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Input
                        label="Email"
                        required
                        {...field}
                        ref={inputRef}
                        onBlur={form.handleSubmit(onSubmit)}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </form>
          </Form>
        ) : (
          <div className="flex items-center justify-between rounded-[8px] border border-[#00000026] px-4 py-3.5 text-[14px] xl:px-[20px] xl:py-6">
            <div>
              <p className="xl:text-[16px]">{curEmail}</p>
              <p className="mt-2 text-[12px] text-[#86868B] xl:mt-3 xl:text-base">
                {t('order_updates_will_be_sent')}
              </p>
            </div>
            <div
              onClick={handleEditEmail}
              className="flex h-[30px] w-[30px] cursor-pointer items-center justify-center">
              <ItemEditIcon />
            </div>
          </div>
        )}

        <div className="flex items-center pb-1 pt-4 xl:pt-6">
          <Checkbox
            rounded={responsive && !responsive.xl}
            checked={isSubscribe}
            onCheckedChange={onSubscribeChange}
          />
          <span className="ml-2 text-[12px] text-[#222223] xl:text-base">
            {t('subscribe_to_newsletter')}
          </span>
        </div>
      </div>
    </div>
  )
})

ContactInformation.displayName = 'ContactInformation'

export default memo(ContactInformation)
